/** Fixed 59.25 mm label pagination for XP-P203A gap stock. */

import type { TsplJobPart } from './tsplEncode';

export const DOTS_PER_MM = 8;
export const LABEL_TOP_Y = 8;
export const LABEL_BOTTOM_MARGIN_DOTS = 8;

export type TsplDrawBlock = {
  heightDots: number;
  /** Emit TSPL command parts at the given Y origin (dots). */
  render: (y: number) => TsplJobPart[];
};

/** Usable vertical space on one physical label. */
export function labelUsableHeightDots(heightMm: number): number {
  const total = Math.floor(heightMm * DOTS_PER_MM);
  return total - LABEL_TOP_Y - LABEL_BOTTOM_MARGIN_DOTS;
}

/** Split draw blocks across pages without splitting a single block. */
export function paginateDrawBlocks(blocks: TsplDrawBlock[], maxY: number): TsplDrawBlock[][] {
  const pages: TsplDrawBlock[][] = [];
  let current: TsplDrawBlock[] = [];
  let y = LABEL_TOP_Y;

  const pushPage = () => {
    if (current.length > 0) {
      pages.push(current);
      current = [];
    }
    y = LABEL_TOP_Y;
  };

  for (const block of blocks) {
    const blockH = block.heightDots;
    const pageCapacity = maxY - LABEL_TOP_Y;

    if (blockH > pageCapacity) {
      if (current.length > 0) pushPage();
      pages.push([block]);
      y = LABEL_TOP_Y;
      continue;
    }

    if (current.length > 0 && y + blockH > maxY) {
      pushPage();
    }

    current.push(block);
    y += blockH;
  }

  if (current.length > 0) pages.push(current);
  return pages.length > 0 ? pages : [[]];
}
